import { render, staticRenderFns } from "./ProviderFields.vue?vue&type=template&id=0b6f7725&scoped=true&"
import script from "./ProviderFields.vue?vue&type=script&lang=js&"
export * from "./ProviderFields.vue?vue&type=script&lang=js&"
import style0 from "./ProviderFields.vue?vue&type=style&index=0&id=0b6f7725&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6f7725",
  null
  
)

export default component.exports